// CONFIGURATION
const STOREFRONT_TOKEN = 'ptkn_29c762d7-082b-4968-a0d3-40db9f9e4f9f';
const BASE_URL = 'https://storefront-api.fourthwall.com/v1';

// --- CRITICAL UPDATE HERE ---
const SHOP_DOMAIN = 'https://checkout.vntg.world'; 
const BACKEND_API_URL = 'https://vntg-api.onrender.com';

// --- HELPER: BASIC REQUEST ---
const request = async (endpoint, currency = 'USD', options = {}) => {
  const separator = endpoint.includes('?') ? '&' : '?';
  const url = `${BASE_URL}${endpoint}${separator}storefront_token=${STOREFRONT_TOKEN}&currency=${currency}`;
  
  const response = await fetch(url, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...options.headers },
  });
  if (!response.ok) throw new Error(`Storefront Error: ${response.status}`);
  return response.json();
};

const cleanVariantName = (variant) => {
  if (variant.attributes?.size?.name) return variant.attributes.size.name;
  let name = variant.name;
  if (typeof document !== 'undefined') {
    const txt = document.createElement("textarea");
    txt.innerHTML = name;
    name = txt.value;
  }
  if (name.includes(',')) return name.split(',').pop().trim();
  if (name.includes('-')) return name.split('-').pop().trim();
  return name;
};

// --- EXPORTS ---

export const getProducts = async (currency = 'USD') => {
  try {
    const collections = await request('/collections', currency);
    if (!collections.results.length) return [];
    
    const slug = collections.results[0].slug; 
    const data = await request(`/collections/${slug}/products`, currency);
    
    return data.results.map(p => ({
      id: p.id,
      slug: p.slug,
      name: p.name,
      price: p.variants[0].unitPrice.value,
      currency: p.variants[0].unitPrice.currency,
      image: p.images[0]?.url,
      variantId: p.variants[0].id,
      defaultVariantId: p.variants[0].id,
      createdAt: new Date(p.createdAt).getTime()
    }));
  } catch (e) {
    console.error("Fetch failed:", e);
    return [];
  }
};

export const getProductBySlug = async (slug) => {
  try {
    const response = await fetch(`${BACKEND_API_URL}/api/product/${slug}`);
    if (!response.ok) throw new Error("Backend not reachable");
    const data = await response.json();

    return {
      id: data.id,
      name: data.name,
      description: data.description, 
      sections: data.sections.map(sec => ({
        title: sec.title,
        content: sec.content_html
      })),
      images: data.images.map(img => img.url),
      variants: data.variants.map(v => ({
        id: v.id,
        name: cleanVariantName(v),
        stock: v.stock,
        prices: v.prices 
      }))
    };
  } catch (e) {
    console.error("Product fetch failed:", e);
    return null;
  }
};

export const createCheckout = async (items, currency = 'USD') => {
  const body = { items: items.map(i => ({ variantId: i.variantId, quantity: i.quantity })) };
  
  // 1. Create Cart
  const data = await request('/carts', currency, { method: 'POST', body: JSON.stringify(body) });
  
  // 2. Redirect to Subdomain Checkout
  return `${SHOP_DOMAIN}/checkout/?cartId=${data.id}&cartCurrency=${currency}`;
};